import type { PropsWithChildren } from 'react'

import type { PostPreviewGridProps } from 'Components'
import {
  MediaIconWrap,
  IsPendingMarker,
  IsApprovedMarker,
  renderPostTypeIcon,
} from 'Components/PostPreviewGrid'

export interface MobilePreviewGridProps {
  posts: PostPreviewGridProps['posts']
  isReadOnly: boolean
}

function MobilePreviewGrid({
  posts,
  isReadOnly,
}: PropsWithChildren<MobilePreviewGridProps>) {
  return (
    <div data-testid="mobile-preview-grid-container">
      <div className="grid max-h-[387px] max-w-[295px] grid-cols-3 gap-[5px] overflow-hidden">
        {posts.map((post) => (
          <div
            key={post.id}
            className={
              'relative aspect-[4/5] w-[95px] [&>img]:absolute [&>img]:inset-0 [&>img]:size-full [&>img]:object-cover' +
              (post.status === 'posted' ? ' opacity-70' : '')
            }
          >
            <img src={post.media.src} alt={post.media.type} />
            <MediaIconWrap>{renderPostTypeIcon(post.media.type)}</MediaIconWrap>
            {post.status === 'pending' && !isReadOnly && <IsPendingMarker />}
            {post.status === 'approved' && !isReadOnly && (
              <IsApprovedMarker>
                <i className="fa-solid fa-check" aria-hidden="true" />
              </IsApprovedMarker>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default MobilePreviewGrid
